import type { ReactNode } from "react";

import { Stack, Text } from "~/ui";

type Props = {
  hint?: string;
  children: ReactNode;
};

export const FieldWithPrefillHint = ({ hint, children }: Props) => (
  <Stack spacing={4}>
    {children}
    {hint ? (
      <Text size="xs" color="dimmed">
        {hint}
      </Text>
    ) : null}
  </Stack>
);
